import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'

import ModalAddPartner from 'pages/partner/pos/ModalAddPartner'
import ModalCreateUpdate from 'pages/admin/pos/ModalCreateUpdate'
import ModalPosChequeStats from 'pages/parts/ModalPosChequeStats'
import ModalPosTelegramLink from 'pages/parts/ModalPosTelegramLink'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import PosStatusToggles, { POS_STATUSES, togglePosStatus } from 'pages/parts/PosStatusToggles'

import { formatDate, formatMoney, isDateActive, returnSign } from 'helpers/helpers'
import { httpOk, GET, POST, PUT } from 'helpers/api'
import { parseProductTableOrderBy, buildProductTableOrderBy } from 'helpers/productFilterParams'
import { renderSortIndicator } from 'helpers/tableSortIndicator'
import TableDropdown from 'helpers/TableDropdown'

const cellClip = {
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
}

const thLogin = { minWidth: 120, maxWidth: 180, ...cellClip }
const thPos = { minWidth: 160, maxWidth: 320, ...cellClip }

// Списки селектов в фильтре открываем поверх страницы — внутри выпадашки фильтра их обрезало
const SELECT_PORTAL_PROPS = {
	menuPosition: 'fixed',
	menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
	menuPlacement: 'auto',
	styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
}

function Index() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const statuses = POS_STATUSES

	const [data, setData] = useState([])
	const [users, setUsers] = useState([])
	const [countries, setCountries] = useState([])
	const [regions, setRegions] = useState([])
	const [partners, setPartners] = useState([])
	const [selectedItem, setSelectedItem] = useState({ 'type': 'pos', 'tariff': '500000' })
	const [modalPartner, setModalPartner] = useState(false)
	const [copiedLogin, setCopiedLogin] = useState('')
	const [telegramLinkPos, setTelegramLinkPos] = useState(null)
	const [modalCreateUpdate, setModalCreateUpdate] = useState(false)
	const [modalCreateTerminal, setModalCreateTerminal] = useState(false)
	const [modalCreateCashbox, setModalCreateCashbox] = useState(false)
	const [modalCredit, setModalCredit] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const deleteNoteRef = useRef(null)
	const [deleteNote, setDeleteNote] = useState('')
	const [modalServices, setModalServices] = useState(false)
	const [posModules, setPosModules] = useState([])
	const [modalTerminal, setModalTerminal] = useState(false)
	const [modalChequeStats, setModalChequeStats] = useState(false)
	const [chequeStatsPos, setChequeStatsPos] = useState(null)
	const [creditForm, setCreditForm] = useState({ days: 1, until: null })
	const [selectedPosItem, setSelectedPosItem] = useState({})
	const [selectedItemServices, setSelectedItemServices] = useState([])
	const [posBilling, setPosBilling] = useState(null)
	const [terminals, setTerminals] = useState([])
	const [cashiers, setCashiers] = useState([])
	const [createTerminalItem, setCreateTerminalItem] = useState({})
	const [createCashboxItem, setCreateCashboxItem] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const {
		filterData,
		setFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetToInitialFilters,
	} = useFilterSearchPagination({
		initialFilterData: { status_ids: [{ 'id': 1, 'name': "Активный" }] },
		initialPagination: {
			url: '/partner/pos',
			response: null,
		},
	})

	async function createUpdate(e) {
		e.preventDefault();

		var response
		if (!selectedItem.id) {
			response = await POST('/partner/pos', selectedItem, { loader: true })
		} else {
			response = await PUT('/partner/pos', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setSelectedItem({})
			toggleModalCreateUpdate()
		}
	}

	async function searchWithFilter(passedData = {}) {
		var filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }
		var filterUrl = "/partner/pos"
		var urlParams = ""
		checkFilter(filterDataCopy)

		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.no_region)
			urlParams += returnSign(urlParams) + 'no_region=1'
		else if (filterDataCopy.region_id)
			urlParams += returnSign(urlParams) + 'region_id=' + filterDataCopy.region_id
		if (filterDataCopy.partner_id)
			urlParams += returnSign(urlParams) + 'partner_id=' + filterDataCopy.partner_id
		if (filterDataCopy.status_ids && filterDataCopy.status_ids.length > 0) {
			const ids = filterDataCopy.status_ids.map(item => item.id).join(',')
			urlParams += returnSign(urlParams) + 'status_ids=' + ids
		}
		if (filterDataCopy.credit_only)
			urlParams += returnSign(urlParams) + 'credit_only=1'
		if (filterDataCopy.order_by)
			urlParams += returnSign(urlParams) + 'order_by=' + filterDataCopy.order_by
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (`/partner/pos${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	async function handleSelectCountry(option) {
		patchFilterData({ 'country_id': option ? option.id : null })
		if (option) getRegions(option.id)
	}

	async function handleSelectRegion(option) {
		patchFilterData({ 'region_id': option ? option.id : null, 'no_region': false })
	}

	function getTodayDate() {
		const d = new Date()
		d.setHours(0, 0, 0, 0)
		return d
	}

	/** Окно: 1–4 текущего месяца, либо с 28-го — 1–4 следующего. */
	function getPartnerTrustWindow() {
		const today = getTodayDate()
		const day = today.getDate()
		if (day >= 1 && day <= 4) {
			const min = today
			const max = new Date(today.getFullYear(), today.getMonth(), 4)
			if (min > max) return null
			return { min, max }
		}
		if (day >= 28) {
			const next = new Date(today.getFullYear(), today.getMonth() + 1, 1)
			return {
				min: new Date(next.getFullYear(), next.getMonth(), 1),
				max: new Date(next.getFullYear(), next.getMonth(), 4),
			}
		}
		return null
	}

	function getPartnerTrustMinDate() {
		return getPartnerTrustWindow()?.min ?? getTodayDate()
	}

	function getPartnerTrustMaxDate() {
		return getPartnerTrustWindow()?.max ?? getTodayDate()
	}

	function isPartnerTrustWindowOpen() {
		return !!getPartnerTrustWindow()
	}

	function daysFromToday(date) {
		if (!date) return 0
		const today = getTodayDate()
		const target = new Date(date)
		target.setHours(0, 0, 0, 0)
		const days = Math.round((target - today) / 86400000)
		return Math.max(0, days)
	}

	function openCreditModal(item) {
		if (!item?.is_trust_payment_available || !isPartnerTrustWindowOpen()) return
		const minDate = getPartnerTrustMinDate()
		const maxDate = getPartnerTrustMaxDate()
		const until = minDate > maxDate ? maxDate : minDate
		setSelectedItem(item)
		setCreditForm({ days: daysFromToday(until), until })
		setModalCredit(true)
	}

	async function activateCredit(e) {
		if (e?.preventDefault) e.preventDefault()
		if (!isPartnerTrustWindowOpen()) return
		const minDays = daysFromToday(getPartnerTrustMinDate())
		const maxDays = daysFromToday(getPartnerTrustMaxDate())
		const days = Math.max(minDays, Math.min(maxDays, parseInt(creditForm.days, 10) || minDays))
		const response = await PUT('/pos/activate-credit', {
			login: selectedItem.login,
			pos_id: selectedItem.id,
			days,
		}, { loader: true })
		if (httpOk(response)) {
			setModalCredit(false)
			searchWithFilter()
		}
	}

	// удалить точку партнёр может только если она заблокирована за неуплату
	function openDeleteModal(item) {
		setSelectedItem(item)
		setDeleteNote('')
		setModalDelete(true)
	}

	async function deletePos(e) {
		e.preventDefault()

		if (!deleteNote.trim()) return

		const response = await PUT('/partner/pos/change-status', {
			'id': selectedItem.id,
			'status': -3,
			'note': deleteNote.trim(),
		}, { loader: true })

		if (!httpOk(response)) return

		setModalDelete(false)
		searchWithFilter()
	}

	async function toggleModalCreateUpdate(bool = false, item = { 'tariff': '500000', 'balance': '0' }) {
		if (!users.length) getUsers()
		if (!item.id) item.type = 1
		setSelectedItem(item)
		setModalCreateUpdate(bool)
	}

	async function toggleModalPartner(bool = false, item = {}) {
		setSelectedItem({ 'id': item.id, 'partner_id': null, 'partner_percentage': '' })
		setModalPartner(bool)
	}

	function openCreateTerminalModal(item) {
		setSelectedPosItem(item)
		setCreateTerminalItem({
			name: '',
			password: '',
		})
		setModalCreateTerminal(true)
	}

	function openCreateCashboxModal(item) {
		setSelectedPosItem(item)
		setCreateCashboxItem({
			name: '',
			is_auto: false,
			is_default: false,
		})
		setModalCreateCashbox(true)
	}

	async function createTerminal(e) {
		e.preventDefault()

		const response = await POST(
			`/partner/pos/${selectedPosItem.id}/terminals`,
			createTerminalItem,
			{ loader: true }
		)

		if (httpOk(response)) {
			setModalCreateTerminal(false)
		}
	}

	async function createCashbox(e) {
		e.preventDefault()

		const response = await POST(
			`/partner/pos/${selectedPosItem.id}/cashbox`,
			createCashboxItem,
			{ loader: true }
		)

		if (httpOk(response)) {
			setModalCreateCashbox(false)
		}
	}

	async function loadPosServices(posId) {
		const response = await GET(`/partner/pos/${posId}/subscription-services`, {}, { loader: true })
		if (httpOk(response)) {
			setSelectedItemServices(response.data?.data || [])
			setPosBilling(response.data?.billing || null)
			setPosModules(response.data?.modules || [])
		}
	}

	// Агент подключает клиенту модуль: 14 дней пробы, потом в счёт клиента
	async function togglePosModule(module) {
		const response = await PUT(`/partner/pos/${selectedItem.id}/module`, {
			code: module.code,
			is_active: !module.is_active,
		}, { loader: true })
		if (httpOk(response)) {
			loadPosServices(selectedItem.id)
		}
	}

	function getActiveBillingServices(list = []) {
		const now = new Date()
		return list.filter((item) => {
			if (Number(item.status) !== 1) return false
			if (!item.ended_at) return true
			const ended = new Date(item.ended_at)
			ended.setHours(23, 59, 59, 999)
			return ended >= now
		})
	}

	async function toggleModalServices(bool = false, item = {}) {
		if (bool) {
			await loadPosServices(item.id)
			setSelectedItem({ id: item.id, tariff: item.tariff, name: item.name })
		} else {
			setSelectedItemServices([])
			setPosBilling(null)
			setPosModules([])
		}
		setModalServices(bool)
	}

	function copyLogin(login) {
		navigator.clipboard.writeText(login)
		setCopiedLogin(login)
		toast.dismiss()
		toast.success(`${login} — скопировано`)
	}

	async function toggleModalTerminal(bool = false, item = {}) {
		if (bool) {
			setSelectedPosItem(item)
			const responseTerminal = await GET(`/partner/helper/terminals/${item.id}`)
			if (httpOk(responseTerminal)) setTerminals(responseTerminal.data)

			const responseCashiers = await GET(`/partner/helper/cashiers/${item.id}`)
			if (httpOk(responseCashiers)) setCashiers(responseCashiers.data)
		} else {
			setTerminals([])
			setCashiers([])
		}
		setModalTerminal(bool)
	}

	function openChequeStatsModal(item) {
		setChequeStatsPos(item)
		setModalChequeStats(true)
	}

	function resetFilter() {
		resetToInitialFilters((nextFilterData) => {
			const resetFilterData = {
				...nextFilterData,
				status_ids: [],
			}
			setFilterData(resetFilterData)
			searchWithFilter({
				filterData: resetFilterData,
			})
		})
	}

	function checkFilter(currentFilterData) {
		if ((!currentFilterData.status_ids || currentFilterData.status_ids.length === 0) && !currentFilterData.credit_only) {
			setFilterDataExist(false)
		}
	}

	function posSortStateForIndicator(fd) {
		const { field, sort } = parseProductTableOrderBy(fd.order_by)
		return { order_by: field, sort }
	}

	function handlePosTableSort(fieldKey) {
		const { field: currentField, sort: currentSort } = parseProductTableOrderBy(filterData.order_by)
		const nextSort = currentField === fieldKey ? (currentSort === 'asc' ? 'desc' : 'asc') : 'asc'
		const order_by = buildProductTableOrderBy(fieldKey, nextSort)
		const nextFilterData = { ...filterData, order_by, page: null }
		patchFilterData({ order_by, page: null })
		searchWithFilter({ filterData: nextFilterData })
	}

	function toggleDropdown(isOpen) {
		setDropdownIsOpen(!!isOpen)
	}

	// Клик по плашке статуса — включить/выключить статус в фильтре и сразу применить
	function toggleStatusFilter(id) {
		const nextFilterData = { ...filterData, status_ids: togglePosStatus(filterData.status_ids, id), page: null }
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	// Клик по плашке «Кредит» — показать только точки с неоплаченным доверительным платежом
	function toggleCreditFilter() {
		const nextFilterData = { ...filterData, credit_only: !filterData.credit_only, page: null }
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	function returnClassStatus(status) {
		if (status === 1) {
			return "bg-primary"
		}
		if (status === -1) {
			return "bg-danger"
		}
		if (status === -2) {
			return "bg-secondary"
		}
		if (status === -3) {
			return "bg-danger"
		}
	}

	async function getUsers() {
		var response = await GET('/partner/owners')
		if (httpOk(response)) setUsers(response.data)
	}

	async function getPartners() {
		var response = await GET('/partner/helper/partners')
		if (httpOk(response)) setPartners(response.data)
	}

	async function getCountries() {
		const response = await GET('/helper/countries')
		if (httpOk(response)) setCountries(response.data)
	}

	async function getRegions(country_id) {
		const response = await GET(`/helper/regions/${country_id}`)
		if (httpOk(response)) setRegions(response.data)
	}

	useEffect(() => {
		getPartners()
		getCountries()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="vertical-center">
					<h4>{t('poses')} [{data.total}]</h4>
				</div>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModalCreateUpdate(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, (nextFilterData) => {
										searchWithFilter({ filterData: nextFilterData })
									})}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown autoClose="outside" onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter" onClick={(e) => e.stopPropagation()}>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('status')}</label>
												<Select
													{...SELECT_PORTAL_PROPS}
													isMulti
													isClearable
													options={statuses}
													value={filterData.status_ids ?? []}
													onChange={(options) => patchFilterData({ 'status_ids': options ? options : [] })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('users')}</label>
												<Select
													{...SELECT_PORTAL_PROPS}
													isClearable
													options={partners}
													value={partners.find(option => option.id === filterData.partner_id) || ''}
													onChange={(option) => patchFilterData({ 'partner_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name || option.login}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('countries')}<span className="required-mark">*</span></label>
												<Select
													{...SELECT_PORTAL_PROPS}
													isClearable
													options={countries}
													value={countries.find(option => option.id === filterData.country_id) || ''}
													onChange={(option) => handleSelectCountry(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('regions')}</label>
												<Select
													{...SELECT_PORTAL_PROPS}
													isClearable
													options={regions}
													value={regions.find(option => option.id === filterData.region_id) || ''}
													onChange={(option) => handleSelectRegion(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-2">
											<div className="form-group col-md-12">
												<div className="form-check mb-0">
													<input
														id="pos-filter-no-region"
														className="form-check-input"
														type="checkbox"
														checked={!!filterData.no_region}
														onChange={(e) => setFilterData({ ...filterData, 'no_region': e.target.checked, 'region_id': e.target.checked ? null : filterData.region_id })}
													/>
													<label className="form-check-label" htmlFor="pos-filter-no-region">
														{t('poses_no_region')}
													</label>
												</div>
												<div className="form-check mb-0">
													<input
														id="pos-filter-credit-only"
														className="form-check-input"
														type="checkbox"
														checked={!!filterData.credit_only}
														onChange={(e) => setFilterData({ ...filterData, 'credit_only': e.target.checked })}
													/>
													<label className="form-check-label" htmlFor="pos-filter-credit-only">
														{t('poses_only_credit')}
													</label>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => applyFilters((nextFilterData) => {
															searchWithFilter({ filterData: nextFilterData })
														})}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<PosStatusToggles counts={data?.status} statusIds={filterData.status_ids}
								onToggle={toggleStatusFilter}
								creditOn={!!filterData.credit_only} onCreditToggle={toggleCreditFilter} />
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
								{filterData.status_ids?.length > 0 &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{filterData.status_ids.map(item => item.name).join(', ')}
									</span>
								}
								{filterData.credit_only &&
									<span className="me-2">
										<b>{t('poses_only_credit')}</b>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0" style={{ minWidth: 1100 }}>
							<thead>
								<tr>
									<th style={{ minWidth: 33 }} className="text-center">#</th>
									<th style={{ minWidth: 40 }} className="text-center">ID</th>
									<th style={thLogin}>{t('login')}</th>
									<th style={thPos}>{t('pos')}</th>
									<th style={{ minWidth: 105 }} className="td-ellipsis">{t('region')}</th>
									<th style={{ minWidth: 105 }}>{t('phone')}</th>
									<th
										style={{ minWidth: 90 }}
										className="text-end th-sortable user-select-none"
										onClick={() => handlePosTableSort('tariff')}
										title={t('sort_by')}
									>
										<div className="d-flex align-items-center justify-content-end gap-1">
											<span>{t('tariff')}</span>
											{renderSortIndicator('tariff', posSortStateForIndicator(filterData))}
										</div>
									</th>
									<th style={{ minWidth: 50 }} className="text-end">%</th>
									<th
										style={{ minWidth: 90 }}
										className="text-end th-sortable user-select-none"
										onClick={() => handlePosTableSort('balance')}
										title={t('sort_by')}
									>
										<div className="d-flex align-items-center justify-content-end gap-1">
											<span>{t('balance')}</span>
											{renderSortIndicator('balance', posSortStateForIndicator(filterData))}
										</div>
									</th>
									<th style={{ minWidth: 88 }} className="text-center">{t('created')}</th>
									<th
										style={{ minWidth: 88 }}
										className="text-center th-sortable user-select-none"
										onClick={() => handlePosTableSort('credit')}
										title={t('sort_by')}
									>
										<div className="d-flex align-items-center justify-content-center gap-1">
											<span>{t('credit')}</span>
											{renderSortIndicator('credit', posSortStateForIndicator(filterData))}
										</div>
									</th>
									<th
										style={{ minWidth: 88 }}
										className="td-ellipsis text-center th-sortable user-select-none"
										onClick={() => handlePosTableSort('cheque')}
										title={t('last_cheque')}
									>
										<div className="d-flex align-items-center justify-content-center gap-1">
											<span className="td-ellipsis">{t('last_cheque')}</span>
											{renderSortIndicator('cheque', posSortStateForIndicator(filterData))}
										</div>
									</th>
									<th
										style={{ minWidth: 72 }}
										className="text-center th-sortable user-select-none"
										onClick={() => handlePosTableSort('version')}
										title={t('sort_by')}
									>
										<div className="d-flex align-items-center justify-content-center gap-1">
											<span>{t('cashbox')}</span>
											{renderSortIndicator('version', posSortStateForIndicator(filterData))}
										</div>
									</th>
									<th style={{ minWidth: 88 }} className="text-center">{t('status')}</th>
									<th style={{ minWidth: 40 }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td
											className="text-center cursor"
											style={{ cursor: 'pointer' }}
											onClick={(e) => {
												e.stopPropagation()
												toggleModalTerminal(true, item)
											}}
										>
											<b>{item.id}</b>
										</td>
										{/* иконка прижата к правому краю ячейки, а не к тексту:
											иначе у длинных и коротких логинов она пляшет по строке */}
										<td className="position-relative" style={{ ...thLogin, paddingRight: '26px' }}>
											<span role="button"
												title={copiedLogin === item.login ? 'Скопировано' : 'Нажмите, чтобы скопировать логин'}
												onClick={() => copyLogin(item.login)}>
												{item.login}
											</span>
											{item.has_telegram_chat ?
												<i className="uil-telegram-alt text-primary position-absolute"
													style={{ right: '7px', top: '50%', transform: 'translateY(-50%)' }}
													title="Есть Telegram-группа"></i>
												:
												// группы нет — красная иконка выдаёт ссылку, которую партнёр отправит клиенту
												<i className="uil-telegram-alt text-danger position-absolute"
													role="button"
													style={{ right: '7px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
													title="Telegram-группа не подключена — получить ссылку"
													onClick={(e) => {
														e.stopPropagation()
														setTelegramLinkPos(item)
													}}></i>
											}
										</td>
										<td style={thPos} title={item.name}>{item.name}</td>
										<td className="td-ellipsis" title={item.region_name}>{item.region_name}</td>
										<td>{item.phone}</td>
										<td
											className="text-end text-nowrap cursor"
											style={{ cursor: 'pointer' }}
											title={
												Number(item.services_total) > 0
													? `Абонентка: ${formatMoney(item.tariff)} + услуги: ${formatMoney(item.services_total)}`
													: 'Состав тарифа'
											}
											onClick={() => toggleModalServices(true, item)}
										>
											{formatMoney(item.monthly_total ?? item.tariff)}
										</td>
										<td className="text-end">{formatMoney(item.partner_percentage)}</td>
										<td className="text-end">{formatMoney(item.balance)}</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td
											className={`text-center ${item.is_trust_payment_available && isPartnerTrustWindowOpen() ? 'cursor' : ''}`}
											style={item.is_trust_payment_available && isPartnerTrustWindowOpen() ? { cursor: 'pointer' } : undefined}
											title={item.is_trust_payment_available && isPartnerTrustWindowOpen() ? 'Доверительный платеж' : undefined}
											onClick={() => openCreditModal(item)}
										>
											{isDateActive(item.billing_free_until) &&
												<div className="text-success fw-semibold" title="Бесплатный период">
													{formatDate(item.billing_free_until)}
												</div>
											}
											{item.trust_granted_to &&
												<div className="text-danger fw-semibold" title="Доверительный доступ">
													{formatDate(item.trust_granted_to)}
												</div>
											}
											{!isDateActive(item.billing_free_until) && !item.trust_granted_to &&
												<span className="text-muted">—</span>
											}
										</td>
										<td
											className="text-center cursor"
											style={{ cursor: 'pointer' }}
											title={t('last_cheque')}
											onClick={() => openChequeStatsModal(item)}
										>
											{formatDate(item.last_cheque_date) || '—'}
										</td>
										<td className="text-center">{item.desktop_client_version}</td>
										<td
											className={`text-center text-white ${item.status === -1 ? 'cursor' : ''} ${returnClassStatus(item.status)}`}
											style={item.status === -1 ? { cursor: 'pointer' } : {}}
											title={item.status === -1 ? t('delete') : ''}
											onClick={() => { if (item.status === -1) openDeleteModal(item) }}
										>
											{item.status === 1 &&
												<span>{t('activated')}</span>
											}
											{item.status === -1 &&
												<span>{t('disconnected')}</span>
											}
											{item.status === -3 &&
												<span>{t('deleted')}</span>
											}
										</td>
										<td>
											<TableDropdown id={`dropdown-${index}`}>
												<div className="table-dropdown-item"
													onClick={() => toggleModalCreateUpdate(true, item)}>
													<i className="uil-edit-alt"></i>
													{t('edit')}
												</div>
												<div className="table-dropdown-item"
													onClick={() => toggleModalPartner(true, item)}>
													<i className="uil-users-alt"></i>
													{t('partners')}
												</div>
												<div className="table-dropdown-item"
													onClick={() => toggleModalServices(true, item)}>
													<i className="uil-bill"></i>
													Тариф / услуги
												</div>
												<div className="table-dropdown-item"
													onClick={() => toggleModalTerminal(true, item)}>
													<i className="uil-desktop"></i>
													Терминал
												</div>
												<div className="table-dropdown-item"
													onClick={() => openCreateTerminalModal(item)}>
													<i className="uil-plus-circle"></i>
													{t('create_terminal')}
												</div>
												<div className="table-dropdown-item"
													onClick={() => openCreateCashboxModal(item)}>
													<i className="uil-plus-circle"></i>
													{t('create_cashbox')}
												</div>
												{!!item.is_trust_payment_available && isPartnerTrustWindowOpen() &&
													<div className="table-dropdown-item"
														onClick={() => openCreditModal(item)}>
														<i className="uil-arrow-right"></i>
														Доверительный платеж
													</div>
												}
												<div className="table-dropdown-item"
													onClick={() => navigate(`/partner/pos-status-history?pos_id=${item.id}`)}>
													<i className="uil-history"></i>
													{t('pos_status_history')}
												</div>
												{item.status === -1 &&
													<div className="table-dropdown-item text-danger"
														onClick={() => openDeleteModal(item)}>
														<i className="uil-trash-alt"></i>
														{t('delete')}
													</div>
												}
											</TableDropdown>
										</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data.total_tariff)}</b></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={(page) => {
								paginate(page)
								searchWithFilter({ filterData: { ...filterData, page } })
							}}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL TRUST CREDIT */}
			<Modal show={modalCredit} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalCredit(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						Доверительный платеж — #{selectedItem.id} {selectedItem.name || ''}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={activateCredit} autoComplete="off">
						<div className="form-group">
							<label>До даты</label>
							<div className="calendar-input">
								<DatePicker
									className="form-control"
									dateFormat="dd.MM.yyyy"
									minDate={getPartnerTrustMinDate()}
									maxDate={getPartnerTrustMaxDate()}
									selected={creditForm.until}
									onChange={(date) => {
										if (!date) return
										const minDate = getPartnerTrustMinDate()
										const maxDate = getPartnerTrustMaxDate()
										let capped = date
										if (capped < minDate) capped = minDate
										if (capped > maxDate) capped = maxDate
										setCreditForm({
											days: daysFromToday(capped),
											until: capped,
										})
									}}
									placeholderText="Выберите дату"
									withPortal
								/>
								<i className="uil uil-calendar-alt"></i>
							</div>
						</div>
						<div className="text-muted small mb-3">
							С 1 по 4 число — до 4-го текущего месяца; с 28-го — 1–4 следующего
							(до {formatDate(getPartnerTrustMaxDate())}). Один раз за период.
						</div>
						<div className="d-flex w-100">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => setModalCredit(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								Включить
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL TRUST CREDIT */}

			{/* MODAL DELETE POS */}
			<Modal show={modalDelete} animation={false} centered
				dialogClassName="update-modal-width"
				onEntered={() => deleteNoteRef.current?.focus()}
				onHide={() => setModalDelete(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('delete')} — #{selectedItem.id} {selectedItem.name || ''}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={deletePos} autoComplete="off">
						<div className="form-group">
							<label>
								{t('note')}<span className="required-mark">*</span>
							</label>
							<textarea
								ref={deleteNoteRef}
								className="form-control"
								rows="3"
								value={deleteNote}
								placeholder={t('pos_delete_reason')}
								onChange={(e) => setDeleteNote(e.target.value)}
							/>
							{!deleteNote.trim() &&
								<div className="text-danger mt-1">{t('pos_delete_reason_required')}</div>
							}
						</div>

						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => setModalDelete(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-danger w-100"
								disabled={!deleteNote.trim()}>
								{t('delete')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL DELETE POS */}

			{/* MODAL CREATE UPDATE*/}
			{modalCreateUpdate &&
				<ModalCreateUpdate
					users={users}
					searchWithFilter={searchWithFilter}
					selectedItem={selectedItem}
					setSelectedItem={setSelectedItem}
					createUpdate={createUpdate}
					modalCreateUpdate={modalCreateUpdate}
					toggleModalCreateUpdate={toggleModalCreateUpdate}
					packagesUrl="/partner/tariff-packages"
					canSetBalance={false}
				>
				</ModalCreateUpdate>
			}
			{/* MODAL CREATE UPDATE*/}

			{/* MODAL CREATE UPDATE*/}
			{modalPartner &&
				<ModalAddPartner
					modalPartner={modalPartner}
					toggleModalPartner={toggleModalPartner}
					selectedItem={selectedItem}
				>
				</ModalAddPartner>
			}
			{/* MODAL CREATE UPDATE*/}

			{/* MODAL CREATE TERMINAL */}
			<Modal show={modalCreateTerminal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalCreateTerminal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('create_terminal')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createTerminal} autoComplete="off">
						<div className="form-group">
							<label>{t('pos')}</label>
							<input type="text" className="form-control" value={selectedPosItem.name ?? ''} disabled />
						</div>
						<div className="form-group">
							<label>{t('name2')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								autoFocus
								value={createTerminalItem.name ?? ''}
								onChange={(e) => setCreateTerminalItem({ ...createTerminalItem, name: e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('password')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="password"
								value={createTerminalItem.password ?? ''}
								onChange={(e) => setCreateTerminalItem({ ...createTerminalItem, password: e.target.value })} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setModalCreateTerminal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE TERMINAL */}

			{/* MODAL CREATE CASHBOX */}
			<Modal show={modalCreateCashbox} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalCreateCashbox(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('create_cashbox')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createCashbox} autoComplete="off">
						<div className="form-group">
							<label>{t('pos')}</label>
							<input type="text" className="form-control" value={selectedPosItem.name ?? ''} disabled />
						</div>
						<div className="form-group">
							<label>{t('cashbox_name')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								autoFocus
								value={createCashboxItem.name ?? ''}
								onChange={(e) => setCreateCashboxItem({ ...createCashboxItem, name: e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('automatic accrual')}</label>
							<div className="d-flex gap-3">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_auto: true })}
										style={{ backgroundColor: createCashboxItem.is_auto ? 'black' : '' }}>
									</div>
									<span onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_auto: true })}>
										{t('yes')}
									</span>
								</div>
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_auto: false })}
										style={{ backgroundColor: !createCashboxItem.is_auto ? 'black' : '' }}>
									</div>
									<span onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_auto: false })}>
										{t('no')}
									</span>
								</div>
							</div>
						</div>
						<div className="form-group">
							<label>{t('default')}</label>
							<div className="d-flex gap-3">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_default: true })}
										style={{ backgroundColor: createCashboxItem.is_default ? 'black' : '' }}>
									</div>
									<span onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_default: true })}>
										{t('yes')}
									</span>
								</div>
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_default: false })}
										style={{ backgroundColor: !createCashboxItem.is_default ? 'black' : '' }}>
									</div>
									<span onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_default: false })}>
										{t('no')}
									</span>
								</div>
							</div>
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setModalCreateCashbox(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE CASHBOX */}

			{/* MODAL SUBSCRIPTION SERVICES (read-only) */}
			<Modal show={modalServices} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalServices()}>
				<Modal.Header closeButton>
					<Modal.Title>Тариф — #{selectedItem.id} {selectedItem.name || ''}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive mb-3">
						<table className="table table-bordered table-sm mb-0">
							<thead>
								<tr>
									<th>Состав ежемесячной суммы</th>
									<th className="text-end" style={{ width: '35%' }}>{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Абонентская плата</td>
									<td className="text-end text-nowrap">
										{formatMoney(posBilling?.tariff ?? selectedItem.tariff)}
									</td>
								</tr>
								{getActiveBillingServices(selectedItemServices).map((item) => (
									<tr key={`bill-${item.id}`}>
										<td>
											{item.name}
											{item.code ? <small className="text-muted"> ({item.code})</small> : null}
										</td>
										<td className="text-end text-nowrap">{formatMoney(item.price)}</td>
									</tr>
								))}
								{getActiveBillingServices(selectedItemServices).length === 0 &&
									<tr>
										<td>Доп. услуги</td>
										<td className="text-end text-nowrap">{formatMoney(0)}</td>
									</tr>
								}
								<tr>
									<td><b>Итого в месяц</b></td>
									<td className="text-end text-nowrap">
										<b>{formatMoney(posBilling?.monthly_total ?? (
											Number(posBilling?.tariff ?? selectedItem.tariff ?? 0)
											+ Number(posBilling?.services_total ?? 0)
										))}</b>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th>Услуга</th>
									<th className="text-end" style={{ width: '25%' }}>{t('price')}</th>
									<th className="text-center" style={{ width: '25%' }}>Статус</th>
								</tr>
							</thead>
							<tbody>
								{selectedItemServices.map((item) => (
									<tr key={item.id}>
										<td>{item.name}</td>
										<td className="text-end text-nowrap">{formatMoney(item.price)}</td>
										<td className="text-center">
											{Number(item.status) === 1 ? t('active') : t('not_active')}
										</td>
									</tr>
								))}
								{selectedItemServices.length === 0 &&
									<tr>
										<td colSpan={3} className="text-center text-muted">{t('list_empty')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>

					{posModules.length > 0 &&
						<div className="table-responsive mt-3">
							<table className="table table-bordered mb-0">
								<thead>
									<tr>
										<th>Модуль</th>
										<th className="text-end" style={{ width: '22%' }}>{t('price')}</th>
										<th className="text-center" style={{ width: '33%' }}>Подключение</th>
									</tr>
								</thead>
								<tbody>
									{posModules.map((module) => (
										<tr key={module.code}>
											<td>
												{module.name}
												{module.scope === 'login' && <small className="text-muted d-block">на весь бренд</small>}
												{module.trial_until && module.is_active &&
													<small className="text-muted d-block">проба до {formatDate(module.trial_until)}</small>
												}
											</td>
											<td className="text-end text-nowrap">{formatMoney(module.price)}</td>
											<td className="text-center">
												{module.grant_reason === 'legacy_snapshot'
													? <span className="text-success">По договору</span>
													: module.is_active
														? <button type="button" className="btn btn-sm btn-outline-danger"
															onClick={() => togglePosModule(module)}>Отключить</button>
														: module.is_available
															? <span className="text-muted">Уже есть у клиента</span>
															: <button type="button" className="btn btn-sm btn-primary"
																onClick={() => togglePosModule(module)}>Подключить</button>
												}
											</td>
										</tr>
									))}
								</tbody>
							</table>
							<small className="text-muted d-block mt-1">
								Подключённый модуль первые 14 дней бесплатный, потом добавляется в ежемесячный счёт клиента.
								Вам — ваш обычный процент с модуля и разовый бонус 50% первого месяца после второй оплаты клиента.
							</small>
						</div>
					}

					<button type="button" className="btn btn-outline-warning w-100 mt-3"
						onClick={() => toggleModalServices()}>
						{t('cancel')}
					</button>
				</Modal.Body>
			</Modal>
			{/* MODAL SUBSCRIPTION SERVICES */}

			{/* MODAL TERMINAL CASHIERS */}
			<Modal show={modalTerminal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalTerminal()}>
				<Modal.Header closeButton>
					<Modal.Title>Терминал</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive mb-2">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th className="text-nowrap" style={{ width: '50%' }}>{t('name2')}</th>
									<th className="text-nowrap" style={{ width: '25%' }}>{t('login')}</th>
									<th className="text-nowrap" style={{ width: '25%' }}>{t('password')}</th>
								</tr>
							</thead>
							<tbody>
								{terminals?.map((item, index) => (
									<tr key={index}>
										<td className="td-ellipsis">{item.name}</td>
										<td className="td-ellipsis">{item.terminal_login}</td>
										<td className="td-ellipsis">{item.password}</td>
									</tr>
								))}
								{(!terminals || terminals.length === 0) &&
									<tr>
										<td colSpan={3} className="text-center text-muted">{t('list_empty')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th className="text-nowrap" style={{ width: '35%' }}>{t('name2')}</th>
									<th className="text-nowrap" style={{ width: '25%' }}>{t('role')}</th>
									<th className="text-nowrap" style={{ width: '20%' }}>{t('pin_code')}</th>
									<th className="text-nowrap" style={{ width: '20%' }}>{t('card_number')}</th>
								</tr>
							</thead>
							<tbody>
								{cashiers?.map((item, index) => (
									<tr key={index}>
										<td className="td-ellipsis">{item.name}</td>
										<td className="td-ellipsis">{item.role_name}</td>
										<td className="td-ellipsis">{item.pin_code}</td>
										<td className="td-ellipsis">{item.card_number}</td>
									</tr>
								))}
								{(!cashiers || cashiers.length === 0) &&
									<tr>
										<td colSpan={4} className="text-center text-muted">{t('list_empty')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL TERMINAL CASHIERS */}
			<ModalPosChequeStats
				show={modalChequeStats}
				onHide={() => setModalChequeStats(false)}
				posItem={chequeStatsPos}
				apiBase="/partner/pos"
			/>
			{/* MODAL TELEGRAM LINK */}
			<ModalPosTelegramLink
				show={!!telegramLinkPos}
				onHide={() => setTelegramLinkPos(null)}
				posItem={telegramLinkPos}
				url="/partner/pos-telegram-link"
			/>
		</>
	)
}

export default Index